import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { HeaderContext } from '@tanstack/react-table';

export interface TransactionListKwhHeaderProps
  extends HeaderContext<TransactionModel, TransactionModel['kwh']> {}

export const TransactionListKwhHeader = (
  props: TransactionListKwhHeaderProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { column } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack key={column.id} justifyContent="flex-end">
      kWh
    </Stack>
  );
};
